import ExerciseGenerator from "./ExerciseGenerator";
//import {getRandomIntegerWithinBitCount, getRandomIntegerWithRange} from "../Random";
import Exercise from "../Exercise";
import ResultItem from "../ResultItem";
import Modes from "../mode/Modes";
import {/*binaryToDecimal,*/ decimalToBinary} from "../logic/Conversion";
import NumberSystems from "../NumberSystems";

export default class FloatingPointExerciseGenerator extends ExerciseGenerator{
    generate = (task) => {
        if(!task){
            task = this.getRandomFloatingPointValue([1, 999], 4);
        }
        let convertedTask;
        let result;
        if(this.mode === Modes.DECIMAL_TO_BINARY_FLOAT){
            convertedTask = task;
            result = new ResultItem(
                decimalToBinary(task),
                NumberSystems.BINARY,
                true,
                true,
                true
            )
        }else if(this.mode === Modes.BINARY_TO_DECIMAL_FLOAT){
            convertedTask = decimalToBinary(task);
            result = new ResultItem(
                task,
                NumberSystems.DECIMAL,
                true,
                true,
                true
            );
        }
        else {
            console.error(this.mode);
            throw new Error("Unknown mode");
        }

        return new Exercise([task], [convertedTask], [result]);
    }

}